export const NumberPercentage = (props) => {
    return (props.number / 100).toLocaleString("EN-AU", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
